module.exports = __webpack_public_path__ + "img/BG.378dea18.svg";